'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sax = require('sax');
var base64Js = require('base64-js');

function decoder(encoded, options) {
    var buffer = base64Js.toByteArray(encoded);
    if (options.precision === '64') {
        return new Float64Array(buffer.buffer);
    } else {
        return new Float32Array(buffer.buffer);
    }
}

function mergeSeries(first, second) {
    var ans = new Array(first.length);
    for (var i = 0; i < ans.length; i++) {
        ans[i] = [first[i], second[i]];
    }
    return ans;
}

/**
 * Reads a mzData v1.05 file
 * @param {ArrayBuffer} data - ArrayBuffer or any Typed Array (including Node.js' Buffer from v4) with the data
 * @return {{times: Array<number>, series: { ms:Array<Array<number>>}}}
 */
function mzData(data) {
    const xml = sax.parser(true, {trim: true});

    var result = {
        times: [],
        series: {}
    };
    var error = [];
    var binaryData = {};
    var mz = [];
    var int = [];
    var kind;

    xml.onopentag = (node) => {
        // eslint-disable-next-line default-case
        switch (node.name) {
            case 'mzData':
                kind = 'mzData';
                break;
            case 'cvParam':
                if (node.attributes.name === 'TimeInMinutes') {
                    result.times.push(Number(node.attributes.value));
                }
                break;
            case 'mzArrayBinary':
                binaryData = {
                    serie: 'mz'
                };
                break;
            case 'intenArrayBinary':
                binaryData = {
                    serie: 'int'
                };
                break;
            case 'data':
                if (binaryData.serie === 'mz') {
                    binaryData = node.attributes;
                    binaryData.serie = 'mz';
                } else if (binaryData.serie === 'int') {
                    binaryData = node.attributes;
                    binaryData.serie = 'int';
                }
                break;
        }
    };

    xml.ontext = (raw) => {
        if (binaryData.serie === 'mz') {
            mz.push(decoder(raw, binaryData));
        } else if (binaryData.serie === 'int') {
            int.push(decoder(raw, binaryData));
        }
        binaryData = {};
    };

    xml.onerror = (err) => error.push(err);
    xml.write(data).close();
    if (!kind || kind !== 'mzData') {
        throw new TypeError('Not a mzData file');
    }
    if (error.length > 0) {
        throw new Error(error);
    }

    result.series.ms = mergeSeries(mz, int);
    return result;
}

exports.mzData = mzData;



// WEBPACK FOOTER //
// ./lib/index.js